// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"ff5c1393","796":"b6328bef"}[chunkId] + ".chunk.js";
};